import request from '@/utils/request'
import { parseTime } from '@/utils'
import moment from "moment";

/**
 * 分页查询任务订单数据
 * @param {*} query 参数
 */
export function getMyTaskOrderPager(query) {
  const response = request({
    url: '/Store/GetMyTaskOrderPager',
    method: 'get',
    params: query
  })
  return new Promise((resolve, reject) => {
    response.then(res => {
      const { code, data } = res
      if (code >= 0 && data.list) {
        const curTime = moment(moment().format('YYYY-MM-DD'))
        data.list = data.list.map(item => {
          item.createTime = parseTime(item.createTime, '{y}-{m}-{d} {h}:{i}')
          item.plantStartDateing = item.plantStartDateing ? parseTime(item.plantStartDateing, '{y}.{m}.{d}') : ''
          item.plantEndDateing = item.plantEndDateing ? parseTime(item.plantEndDateing, '{y}.{m}.{d}') : ''

          const dataTime = moment(moment(item.createTime).format('YYYY-MM-DD'))
          const d = curTime.diff(dataTime, 'days');

          if (d == 0)
            item.createTimeTip = `今天`
          else if (d <= 3)
            item.createTimeTip = `${d}天前`
          else
            item.createTimeTip = dataTime.format('MM.DD')

          return item
        })
      }
      resolve(res)
    }).catch(res => {
      reject(res)
    })
  })
}

// 取消任务订单
export function cancelTaskOrder(data) {
  return request({
    url: '/Store/CancelTaskOrder',
    method: 'post',
    data
  })
}

/**
 * 摄影师分页查询
 * @param {*} query 参数
 */
export function getGrapherPagerByOrder(query) {
  const response = request({
    url: '/Store/GetGrapherPagerByOrder',
    method: 'get',
    params: query
  })
  return response
}

// 派单（更换接单摄影师）
export function replaceGrapher(data) {
  return request({
    url: '/Store/ReplaceGrapher',
    method: 'post',
    data
  })
}

/**
 * 订单详情
 * @param {*} query 参数
 */
export function getTaskOrderDetail(query) {
  const response = request({
    url: '/Store/GetTaskOrderDetail',
    method: 'get',
    params: query
  })
  return new Promise((resolve, reject) => {
    response.then(res => {
      const { code, data } = res
      if (code >= 0 && data) {
        if (data.order) {
          data.order.createTime = parseTime(data.order.createTime, '{y}-{m}-{d} {h}:{i}')
          data.order.plantStartDateing = data.order.plantStartDateing ? parseTime(data.order.plantStartDateing, '{y}.{m}.{d}') : ''
          data.order.plantEndDateing = data.order.plantEndDateing ? parseTime(data.order.plantEndDateing, '{y}.{m}.{d}') : ''
        }
        if (data.orderTrace) {
          data.orderTrace.createTime = parseTime(data.orderTrace.createTime, '{y}-{m}-{d} {h}:{i}')
          data.orderTrace.plantStartDate = data.orderTrace.plantStartDate ? parseTime(data.orderTrace.plantStartDate, '{y}.{m}.{d}') : ''
          data.orderTrace.plantEndDate = data.orderTrace.plantEndDate ? parseTime(data.orderTrace.plantEndDate, '{y}.{m}.{d}') : ''
          data.orderTrace.plantDeliveryDate = data.orderTrace.plantDeliveryDate ? parseTime(data.orderTrace.plantDeliveryDate, '{y}.{m}.{d}') : ''
        }
      }
      resolve(res)
    }).catch(res => {
      reject(res)
    })
  })
}

/**
 * 摄影师分页查询
 * @param {*} query 参数
 */
export function getGrapherPager(query) {
  const response = request({
    url: '/Store/GetGrapherPager',
    method: 'get',
    params: query
  })
  return new Promise((resolve, reject) => {
    response.then(res => {
      const { code, data } = res
      if (code >= 0 && data.list) {
        data.list = data.list.map(item => {
          item.createTime = parseTime(item.createTime, '{y}-{m}-{d} {h}:{i}')
          return item
        })
      }
      resolve(res)
    }).catch(res => {
      reject(res)
    })
  })
}

// 获取摄影师统计信息
export function getPhotoGrapherAuditStatistics(query) {
  return request({
    url: '/Store/GetPhotoGrapherAuditStatistics',
    method: 'get',
    params: query
  })
}

// 摄影师审核
export function auditGrapher(data) {
  return request({
    url: '/Store/Audit',
    method: 'post',
    data
  })
}

/**
 * 产品分页查询
 * @param {*} query 参数
 */
export function getProductPager(query) {
  const response = request({
    url: '/Store/GetProductPager',
    method: 'get',
    params: query
  })
  return new Promise((resolve, reject) => {
    response.then(res => {
      const { code, data } = res
      if (code >= 0 && data.list) {
        data.list = data.list.map(item => {
          if (item.prodtct) {
            item.prodtct.createTime = parseTime(item.prodtct.createTime, '{y}-{m}-{d} {h}:{i}')
          }
          return item
        })
      }
      resolve(res)
    }).catch(res => {
      reject(res)
    })
  })
}

// 更改商品状态（批量操作）
export function updateProductStatusBatch(data) {
  return request({
    url: '/Store/UpdateProductStatusBatch',
    method: 'post',
    data
  })
}

/**
 * 获取产品下的套餐信息
 * @param {*} query 参数
 */
export function getProductDetail(productId) {
  const response = request({
    url: '/Store/GetProductDetail',
    method: 'get',
    params: { productId }
  })
  return new Promise((resolve, reject) => {
    response.then(res => {
      const { code, data } = res
      if (code >= 0 && data) {
        data.map(item => {
          item.createTime = parseTime(item.createTime, '{y}-{m}-{d} {h}:{i}')
          item.startDay = item.startDay ? parseTime(item.startDay, '{y}.{m}.{d}') : ''
          item.endDay = item.endDay ? parseTime(item.endDay, '{y}.{m}.{d}') : ''
        })
        // if (data.product) {
        //   data.product.createTime = parseTime(data.product.createTime, '{y}-{m}-{d} {h}:{i}')
        // }
        // if (data.productPriceConfigs) {
        //   data.productPriceConfigs.map(item => {
        //     item.createTime = parseTime(item.createTime, '{y}-{m}-{d} {h}:{i}')
        //     item.startDay = item.startDay ? parseTime(item.startDay, '{y}.{m}.{d}') : ''
        //     item.endDay = item.endDay ? parseTime(item.endDay, '{y}.{m}.{d}') : ''
        //   })
        // }
      }
      resolve(res)
    }).catch(res => {
      reject(res)
    })
  })
}

// // 套餐上下架（批量操作）
// export function updateProductPriceStatusBatch(data) {
//   return request({
//     url: '/Store/UpdateProductPriceStatusBatch',
//     method: 'post',
//     data
//   })
// }

// 编辑套餐信息
export function updateProductPrice(data) {
  return request({
    url: '/Store/UpdateProductPrice',
    method: 'post',
    data
  })
}

// 审核任务订单
export function auditTaskOrder(data) {
  return request({
    url: '/Store/AuditTaskOrder',
    method: 'post',
    data
  })
}

/**
 * 分页查询（酒店）
 * @param {*} query 参数
 */
export function getHotelPager(query) {
  const response = request({
    url: '/Store/GetHotelPager',
    method: 'get',
    params: query
  })
  return response
}

/**
 * 分页查询（协议公司）
 * @param {*} query 参数
 */
export function getAgreementPager(query) {
  const response = request({
    url: '/Store/GetAgreementPager',
    method: 'get',
    params: query
  })
  return response
}

/**
 * 获取店铺信息
 * @param {*} query 参数
 */
export function getStoreInfo(query) {
  const response = request({
    url: '/Store/GetStoreInfo',
    method: 'get',
    params: query
  })
  return new Promise((resolve, reject) => {
    response.then(res => {
      const { code, data } = res
      if (code >= 0 && data) {
        data.createTime = parseTime(data.createTime, '{y}-{m}-{d} {h}:{i}')
        data.foundingTime = data.foundingTime ? parseTime(data.foundingTime, '{y}-{m}-{d}') : ''
      }
      resolve(res)
    }).catch(res => {
      reject(res)
    })
  })
}

/**
 * 获取店铺的帮助中心信息
 * @param {*} query 参数
 */
export function getHkHelp(query) {
  const response = request({
    url: '/Store/GetHkHelp',
    method: 'get',
    params: query
  })
  return new Promise((resolve, reject) => {
    response.then(res => {
      const { code, data } = res
      resolve(res)
    }).catch(res => {
      reject(res)
    })
  })
}

/**
 * 判断店铺中有没有帮助中心信息
 * @param {*} query 参数
 */
export function IfHavedHkHelp(query) {
  const response = request({
    url: '/Store/IfHavedHkHelpImagesText',
    method: 'get',
    params: query
  })
  return new Promise((resolve, reject) => {
    response.then(res => {
      const { code, data } = res
      resolve(res)
    }).catch(res => {
      reject(res)
    })
  })
}

// 更新店铺信息（基础信息）
export function updateBaseData(data) {
  return request({
    url: '/Store/UpdateBaseData',
    method: 'post',
    data
  })
}

// 提现
export function getCash(data) {
  return request({
    url: '/Store/GetCash',
    method: 'post',
    data
  })
}

// 修改订单中摄影师的结算价
export function modifyOrderActualTotalMoney(data) {
  return request({
    url: '/Store/ModifyOrderActualTotalMoney',
    method: 'post',
    data
  })
}

/**
 * 获取登录用户的店铺信息
 * @param {*} query 参数
 */
export function getStoreExtInfo() {
  return request({
    url: '/Store/GetStoreExtInfo',
    method: 'get',
    //params: query
  })
}

// 获取店铺详细信息
export function getStoreDetail() {
  const response = request({
    url: '/Store/GetStoreDetail',
    method: 'get',
    // params: { storeId: id }
  })
  return new Promise((resolve, reject) => {
    response.then(res => {
      const { code, data } = res
      if (code >= 0 && data) {
        data.createTime = parseTime(data.createTime, '{y}-{m}-{d} {h}:{i}')
        data.storesType = `${data.storesType}`
        data.auditStatus = `${data.auditStatus}`
        data.storeGrade = `${data.storeGrade}`
        data.storeStatus = `${data.storeStatus}`
      }
      resolve(res)
    }).catch(res => {
      reject(res)
    })
  })
}


// WEBPACK FOOTER //
// ./src/api/m/store.js